// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductMiniCard_card__CuEXH","image":"ProductMiniCard_image__OjbdJ","roundedCorner":"ProductMiniCard_roundedCorner___Obg4","title":"ProductMiniCard_title__H1cyf"};